// Checklist row used on the "Approve in your wallet" and "Minting your
// certificate" screens: green check = done, black outline = active,
// grey outline = pending. Matches Figma nodes 3685:913/941/949.
export type BkfcStepState = "done" | "active" | "pending";

export function BkfcStepRow({
  state,
  label,
}: {
  state: BkfcStepState;
  label: string;
}) {
  return (
    <div className="flex gap-3 items-center">
      {state === "done" ? (
        <div className="flex items-center justify-center w-8 h-8 rounded-full bg-[#9EEE72] shrink-0">
          <img src="/svg/bkfc/check-small.svg" alt="" className="w-4 h-4" />
        </div>
      ) : (
        <div
          className={`w-8 h-8 rounded-full border-2 shrink-0 ${
            state === "active" ? "border-black" : "border-[#626262]"
          }`}
        />
      )}

      <span
        className={
          state === "active"
            ? "text-base font-semibold text-black"
            : state === "done"
              ? "text-base font-medium text-black"
              : "text-base font-medium text-[#626262]"
        }
      >
        {label}
      </span>
    </div>
  );
}
